export const ORG_SETTINGS_NAVIGATION_ITEMS = [
  {
    key: 1,
    url: `/organization-settings/features`,
    name: 'Features',
    translationKey: 'features',
  },
  {
    key: 2,
    url: `/organization-settings/permissions`,
    name: 'Permissions',
    translationKey: 'permissions',
  },
  {
    key: 3,
    url: `/organization-settings/documents`,
    name: 'Documents',
    translationKey: 'documents',
  },
  {
    key: 4,
    url: `/organization-settings/profile-info`,
    name: 'Profile info',
    translationKey: 'profileInfo',
  },
];
